import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import AnamneseApp from '../projeto-anamnese/src/App'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AnamneseApp />
    </BrowserRouter>
  </React.StrictMode>
)
